/**
 * 기존 mobile 에서는 react-router를 통해 아래의 주소들이 routing을 위해서 쓰였습니다.
 * web에서는 오로지 page 이동을 위해 쓰이므로 `:visitId([0-9a-f]{24})` 이런식의 표현은 없애도 됩니다.
 */

import { ReceiptFileStatus, RECEIPT_FILE_STATUS_KEY } from '@web/pages/receipt/index.state'
import { MatchedPlaces, VISIT_NEW_QUERY_KEY } from '@web/pages/visit/new/index.state'

import links from './links'

const routes = {
  AD_SETTING: '/ad/setting',
  AD_TERMS: '/ad/terms',
  BLOCKING: '/:userId/blocking',
  BLOCKING_NO_LOGIN: '/blocking',
  BOOKMARK: '/my/bookmark/:placeId',
  CHECKIN: '/checkin',
  CLIP: '/clip/:videoId',
  DISCOVERY: '/discovery',
  FEED_REGION: '/feed/region',
  FOLLOWERS: '/:userId/followers',
  FOLLOWERS_NO_LOGIN: '/followers',
  FOLLOWING: '/:userId/following',
  FOLLOWING_NO_LOGIN: '/following',
  TIMELINE_LIST: '/timeline',
  TIMELINE_WITH_DATE: '/timeline?dateRangeFrom=&dateRangeTo=',
  HOME: '/',
  HOME_OLD: '/home',
  HOME_FEED: '/following-feed',
  HOME_REVIEW: '/:userId/review',
  HOME_MY_REVIEW: '/review',
  HOME_REVIEW_DETAIL: '/:id/review/:reviewId([0-9a-f]{24})',
  HOME_REVIEW_EDIT: '/:id/review/:reviewId([0-9a-f]{24})/edit',
  HOME_REVIEW_NEW: '/:id/review/:visitId([0-9a-f]{24})/new',
  HOME_REVIEW_REPLY: '/:id/review/:reviewId([0-9a-f]{24})/reply',
  HOME_THEME: '/:id/theme',
  HOME_VISIT: '/visit',
  MISSION: '/mission',
  MISSION_HISTORY: '/mission/history?lastMonth=',
  ONBOARDING: '/onboarding/:step([1-3])',
  PAYMENTS: '/payments',
  PAYMENT_CHECKIN: '/checkin/payment',
  POLICY: '/policy',
  POLICY_MY_PLACE: '/policy/myplace',
  POLICY_VISITOR_REVIEW: '/policy/visitorReview',
  REACTIONS: '/reactions',
  RECEIPT: '/checkin/receipt',
  RECEIPT_SCANNING: `/checkin/receipt?${RECEIPT_FILE_STATUS_KEY}=${ReceiptFileStatus.SCANNING}`,
  RECEIPT_SCAN_CHECKED_IN: `/checkin/receipt?${RECEIPT_FILE_STATUS_KEY}=${ReceiptFileStatus.CHECKED_IN}`,
  RECEIPT_SCAN_DUPLICATED: `/checkin/receipt?${RECEIPT_FILE_STATUS_KEY}=${ReceiptFileStatus.DUPLICATED}`,
  RECEIPT_SCAN_FAILED: `/checkin/receipt?${RECEIPT_FILE_STATUS_KEY}=${ReceiptFileStatus.SCAN_FAILED}`,
  RECEIPT_SCAN_REWARDED: `/checkin/receipt?${RECEIPT_FILE_STATUS_KEY}=${ReceiptFileStatus.REWARDED}`,
  RECEIPT_VIEW: '/receipt/:receiptId',
  REVIEW_DETAIL: '/review/:reviewGroupId',
  REVIEW_FEED_OLD: '/:userId/reviewfeed/:reviewGroupId?sort=&mediaFilter=&placeCategoryId=&regionCode=',
  REVIEW_FEED: '/:userId/reviewfeed?sort=&mediaFilter=&placeCategoryId=&regionCode=&reviewId=',
  REVIEW_EDIT: '/review/edit/:reviewGroupId',
  REVIEW_NEW: '/review/new/visit/:visitId',
  REVIEW_BRIDGE: '/open/review',
  REVIEW_PAYMENT_INFO: '/review/:reviewGroupId/paymentInfo',
  REVIEW_PAYMENT_INFO_NO_AUTH: '/review/:reviewGroupId/paymentInfo/noAuth',
  REVIEW_REPORT: '/review/:reviewGroupId/report',
  SETTING: '/setting',
  SETTING_PROFILE: '/setting/profile',
  TERMS_POLICY_MY_PLACE: '/terms/policy/myplace',
  TERMS_POLICY_VISITOR_REVIEW: '/terms/policy/visitorReview',
  THEME_EDIT: '/theme/:themeId/edit',
  THEME_END: '/theme/:themeId',
  THEME_MAP: '/theme/:themeId/map',
  THEME_NEW: '/theme/new',
  VISIT_DETAIL: '/visit/:visitId',
  VISIT_NEW: '/visit/new',
  VISIT_NEW_MULTIPLE: `/visit/new?${VISIT_NEW_QUERY_KEY}=${MatchedPlaces.MULTIPLE}`,
  VISIT_NEW_NONE: `/visit/new?${VISIT_NEW_QUERY_KEY}=${MatchedPlaces.NONE}`,
  VISIT_NEW_SEARCH: `/visit/new?${VISIT_NEW_QUERY_KEY}=${MatchedPlaces.SEARCH}`,
  VISIT_NEW_SINGLE: `/visit/new?${VISIT_NEW_QUERY_KEY}=${MatchedPlaces.SINGLE}`,
  YEAR_END: '/year-end/:year',
  ...links,
} as const

export default routes
